import type { SVGProps } from 'react';

const SvgRankingTwo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={32}
    viewBox='0 0 32 32'
    width={32}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M24 27.333h-1.333V27c0-1.467-1.2-2.667-2.667-2.667h-3V21.28c-.333.04-.667.053-1 .053s-.667-.013-1-.053v3.053h-3A2.674 2.674 0 0 0 9.333 27v.333H8c-.547 0-1 .454-1 1 0 .547.453 1 1 1h16c.547 0 1-.453 1-1s-.453-1-1-1'
      fill='#85A0C9'
    />
    <path
      d='M7.36 15.52c-.88-.333-1.653-.88-2.267-1.493-1.24-1.374-2.053-3.014-2.053-4.934a3.39 3.39 0 0 1 3.427-3.426h.746A5.3 5.3 0 0 0 6.667 8v4c0 1.253.24 2.44.693 3.52M28.96 9.093c0 1.92-.814 3.56-2.054 4.934-.613.613-1.386 1.16-2.266 1.493a9.1 9.1 0 0 0 .693-3.52V8c0-.84-.2-1.627-.547-2.333h.747a3.39 3.39 0 0 1 3.427 3.426'
      fill='#97B1D7'
    />
    <path
      d='M20 2.667h-8A5.33 5.33 0 0 0 6.667 8v4A9.327 9.327 0 0 0 16 21.333 9.327 9.327 0 0 0 25.333 12V8A5.33 5.33 0 0 0 20 2.667'
      fill='#B2C5E2'
    />
    <g filter='url(#ranking-two)'>
      <path
        d='m13.242 14.828 2.796-2.57q.414-.398.64-.661.23-.264.355-.522a1.3 1.3 0 0 0 .123-.559q0-.339-.161-.591a1 1 0 0 0-.44-.387 1.4 1.4 0 0 0-.635-.14q-.549 0-.877.328-.327.322-.327.876h-1.538q-.005-.752.338-1.317.35-.564.979-.871.63-.306 1.446-.307.824.001 1.452.296.63.29.973.812.35.522.35 1.194 0 .456-.178.881-.177.42-.618.941-.436.516-1.237 1.242l-1.183 1.15v.044h3.323V16h-5.57z'
        fill='#fff'
      />
    </g>
    <defs>
      <filter
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
        height={13.226}
        id='ranking-two'
        width={10.978}
        x={10.511}
        y={5.441}
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset />
        <feGaussianBlur stdDeviation={1.333} />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix values='0 0 0 0 0.521569 0 0 0 0 0.627451 0 0 0 0 0.788235 0 0 0 1 0' />
        <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_1192_75047' />
        <feBlend in='SourceGraphic' in2='effect1_dropShadow_1192_75047' result='shape' />
      </filter>
    </defs>
  </svg>
);
export default SvgRankingTwo;
